import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getClinicToken() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getClinicToken`;
    return httpPost(apiUrl);
  }

  getClinicRoom() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getClinicRoom`;
    return httpPost(apiUrl);
  }

  callNumber(data) {
    console.log(data);
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/callNumber`;
    return httpPost(apiUrl, data);
  }

  setAppointment(enable) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/setAppointment?enable=${enable}`;
    return httpPost(apiUrl);
  }

  getImageDetection(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getImageDetection`;
    return httpPost(apiUrl, data);
  }

  getAiLabel(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getAiLabel`;
    return httpPost(apiUrl, data);
  }

  getAnImageDetection(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getAnImageDetection`;
    return httpPost(apiUrl, data);
  }

  getSciKetToken(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/getSciKetToken`;
    return httpPost(apiUrl, data);
  }

  sendSMS(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/sms`;
    return httpPost(apiUrl, data);
  }

  getSmsPoint() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/sms/point`;
    return httpGet(apiUrl);
  }

  getScrmMessages(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/scrm/messageList`;
    return httpPost(apiUrl, data);
  }

  getScrmSetting(type) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/scrm/setting?type=${type}`;
    return httpGet(apiUrl);
  }

  getTerrymonLabelList(type) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/scrm/terrymon/label/list?type=${type}`;
    return httpGet(apiUrl);
  }

  createBreezySignByPDF(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/breezySign/createByPdf`;
    return httpPost(apiUrl, data)
  }

  createBreezySignByDocx(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/external/breezySign/createByDocx`;
    return httpPost(apiUrl, data)
  }
}
